import {connect} from 'react-redux';
import {get} from 'lodash/fp';
import {createStructuredSelector} from 'reselect';

import {
  highestAchievedRankDescriptionById,
  paidAsRankDescLastMonth,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {fromProps, withProps} from '/util/selector.util';

import ProfileContactSection from './ProfileContactSection';

const withCurrentUserId = withProps({
  userId: fromProps(get('userId')),
});

export default connect(
  createStructuredSelector({
    userId: withCurrentUserId(userId),
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
    highestAchievedRank: withProps({coachId: userId})(
      highestAchievedRankDescriptionById,
    ),
  }),
)(ProfileContactSection);
